export default __webpack_public_path__ + "static/media/berlin.93c1f3d6.png";